
function xor(a: boolean, b: boolean): boolean {
  return a ? !b : b;
}

export default xor;